import React from "react";
import ContactUsForm from "../ContactUsForm";
import HeroSection from "../Sections/HeroSection";
import ServicesSection from "../Sections/ServicesSection";
import AboutSection from "../Sections/AboutSection";
import TestimonialsSection from "../Sections/TestimonialsSection";
import FAQSection from "../Sections/FAQSection";

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-white relative">
      {/* Global subtle background pattern */}
      <div className="fixed inset-0 bg-[radial-gradient(circle_at_25%_25%,rgba(37,99,235,0.01),transparent_50%)] pointer-events-none"></div>
      <div className="fixed inset-0 bg-[radial-gradient(circle_at_75%_75%,rgba(8,145,178,0.008),transparent_50%)] pointer-events-none"></div>
      
      {/* Individual Section Components */}
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <TestimonialsSection />
      <FAQSection />
      <ContactUsForm />
    </div>
  );
};

export default Dashboard;
